import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getWaitTimes } from 'services/waitTimes';
import { WaitTimeResponseType } from 'services/waitTimes/types';
import { DEFAULT_RETRIES } from 'utils/axios/constants';

export const useWaitTimes = (): UseQueryResult<WaitTimeResponseType> => {
  const QUERY_KEY = 'waitTimes';
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: getWaitTimes,
    retry: DEFAULT_RETRIES,
    retryOnMount: false,
    refetchOnWindowFocus: false,
  });
};
